export enum LocalStorageKey {
  REPRS = 'REPRS',
  SETTINGS = 'SETTINGS',
}

export const LS_KEY_PREFIX = 'ReprMan'
